import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Button, Form, Message, Segment
} from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { AuthHeader, BottomLink } from './AuthPartials'
import AuthActions from 'Redux/AuthRedux'
import styles from './ForgotPasswordStyles'

class ForgotPasswordForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      email: ''
    }
  }

  onForgotPassword = () => {
    this.props.forgotPasswordRequest(this.state.email)
  }

  onEmailChange = (_, { value }) => {
    this.setState({ email: value })
  }

  render () {
    return (
      <div className={styles.forgotPasswordForm}>
        {this.props.error &&
          <Message color='red'>{this.props.error}</Message>
        }
        {this.props.authData && this.props.authData.message &&
          <Message color='yellow'>{this.props.authData.message}</Message>
        }
        <Form size='large'>
          <Segment stacked>
            <AuthHeader title='Forgot Password' />
            <Form.Input
              fluid
              icon='user'
              iconPosition='left'
              placeholder='E-mail address'
              onChange={this.onEmailChange} />
            <Button
              primary
              fluid
              size='large'
              onClick={this.onForgotPassword}
              loading={this.props.fetching} >
               Reset Password
            </Button>
          </Segment>
        </Form>
        <BottomLink
          text="Remember credentials?"
          link={
            <Link to={'/auth/login'}>Log In</Link>
          }
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  fetching: state.auth.fetching,
  authData: state.auth.authData
})

const mapDispatchToProps = (dispatch) => ({
  forgotPasswordRequest: (email) =>
    dispatch(AuthActions.forgotPasswordRequest(email))
})

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordForm)



// WEBPACK FOOTER //
// ./src/Pages/Auth/ForgotPassword.js